// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exitConfirmation{position:absolute;top:0;bottom:0;left:0;right:0;z-index:999;display:flex;flex-direction:column;justify-content:center;box-sizing:border-box;padding:24px}.exitConfirmation .exitConfirmation__header{margin-top:24px;margin-bottom:4px}.exitConfirmationMessage{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
